<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>


                <div class="panel-tag mt-2">
                    {{__t("POS_PARAMS")}}
                </div>
                <location_general_params :location="location"></location_general_params>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("PWA_LOCATION_PARAMS")}}
                </div>

                <b-tabs content-class="mt-3 mb-4">
                    <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                           :title="get_tab_title(tab)"
                           :key="index"
                           :active="tab.is_active"
                    >
                        <template slot="title">
                            {{get_tab_title(tab)}}
                            <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                        </template>

                        <div class="general_pwa_settings" v-if="tab.index == 'pwa_main_settings'">
                            <div class="form-group mt-2" v-for="general_field in general_fields">

                                <label class="form-label" >
                                    {{general_field.title}}
                                </label>

                                <div class="input-group flex-nowrap" v-if="!(is_bool_field(general_field) || is_editor(general_field))">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fal  fa-typewriter fs-xl" ></i>
                                        </span>
                                    </div>

                                    <input :id="general_field.key" type="text" class="form-control"
                                           v-model="location.general_fields[general_field.key]">
                                </div>

                                <div class="input-group flex-nowrap" v-if="is_bool_field(general_field)">
                                    <b-form-radio-group
                                        :id="'btn-radios-' + general_field.key"
                                        v-model="location.general_fields[general_field.key]"
                                        button-variant="outline-primary"
                                        :options="[
                                              { text: 'YES', value: true },
                                              { text: 'NO', value: false }
                                        ]"
                                        :name="'btn-radios-' + general_field.key"
                                        buttons
                                    ></b-form-radio-group>

                                </div>

                                <div class="editor" v-if="is_editor(general_field)">
                                    <vue-editor :editor-toolbar="editor_rules" v-model="location.general_fields[general_field.key]"></vue-editor>
                                </div>

                            </div>
                        </div>

                        <div class="general_pwa_settings" v-if="tab.index == 'pwa_shipment_settings'">
                            <pwa_shipment_settings :location="location"></pwa_shipment_settings>
                        </div>
                    </b-tab>
                </b-tabs>

            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import { VueEditor } from "vue2-editor";
import pwa_shipment_settings from "./shipment/pwa_shipment_settings.vue";
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";


export default {
    name: "pwa_general_tab",

    components : {
        Location_general_params,
        vSelect,
        VueEditor,
        pwa_shipment_settings
    },

    props : {
        location : {
            type : Object
        }
    },


    data() {
        return {
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],

            tabs : [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "pwa_main_settings",
                    is_active:true,
                },
                {
                    "title": this.__t('PWA_SHIPMENT_TAB'),
                    "index": "pwa_shipment_settings",
                    is_active:false,
                },

            ],
        }
    },

    methods : {

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        is_editor(field) {
            const allowed = ['description'];
            return allowed.includes(field.key);
        },

        is_bool_field(field) {
            return field && typeof field.value === 'boolean';
        },

    },

    computed: {

        general_fields() {
            const skipKeys = ['id', 'shipments','bonus_payment'];

            if (!this.location || !this.location.general_fields) {
                return [];
            }

            return Object.entries(this.location.general_fields)
                .filter(([key]) => !skipKeys.includes(key))
                .map(([key, value]) => ({
                    key,
                    value,
                    title: this.__t(key.toUpperCase())
                }));
        },
    }
}
</script>

<style scoped>

</style>
